// @flow
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { checkUserAccessOnRoute, getRedirectPath } from "../services/helpers";

// this routesConfig arr is also used in server/route.js
import routesConfig from "../configs/routesConfig";

const redirect = pathStr => {
  const redirectPath = getRedirectPath(pathStr, routesConfig);
  return <Redirect to={{ pathname: redirectPath }} />;
};

const getFirstLevelRoutes = () => {
  const newRoutesArray = [];
  routesConfig.map(routeObj => {
    if (routeObj.zoomuinewroute) {
      newRoutesArray.push(routeObj);
    } else if (routeObj.subRoutes && routeObj.subRoutes.length > 0) {
      routeObj.subRoutes.map(subRouteObj => {
        if (subRouteObj.zoomuinewroute) {
          newRoutesArray.push(subRouteObj);
        }
        return null;
      });
    }
    return null;
  });
  return newRoutesArray;
};

const routesArr = getFirstLevelRoutes();

type Props = {
  userProfile: Object,
  history: Object
};

const RouterComp = ({ userProfile, history }: Props) => (
  <div className="routes-wrapper">
    <Switch>
      {routesArr.map((route: Object) => (
        <Route
          key={route.title}
          path={route.route}
          exact={route.exact}
          history={history}
          render={renderProps => {
            const pathStr = renderProps.match.path.split("/")[1];
            const hasRouteAccess = checkUserAccessOnRoute(
              pathStr,
              userProfile,
              routesConfig
            );
            return hasRouteAccess ? (
              <route.component
                history={history}
                params={renderProps.match.params}
              />
            ) : (
              redirect(pathStr)
            );
          }}
        />
      ))}
    </Switch>
  </div>
);

export default RouterComp;



// WEBPACK FOOTER //
// ./app/main/route.js